export const BLOCKED_RESTAURANT_IDS = ['69bd59b55a10b5001b234d1d'];

export const isBlockedRestaurant = (id) => BLOCKED_RESTAURANT_IDS.includes(id);
